export function initializeLinksThatRequireConfirmation(container: HTMLElement): void {
    container.querySelectorAll(`[data-confirm]`)
        .forEach(link => {
            link.addEventListener('click', event => {
                if (! confirm(link.getAttribute('data-confirm') as string)) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                }
            }, true);
        });
}
